import React, { Component } from "react";
import styled from "styled-components";

import {
    Edit as EditIcon,
    Home as HomeIcon,
    Share as ShareIcon,
    ViewModule as ViewModuleIcon,
} from "@material-ui/icons";
import AppController from "js/core/AppController";

const HeaderContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 68px;
    background: #222222;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    z-index: 1000;
    border-bottom: 1px solid #11a9ef;
`;

const LogoText = styled.div`
    color: white;
    display: flex;
    align-items: center;
`;

const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`;

const ActionButton = styled.button`
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0px;
    
    &:hover {
        opacity: 0.7;
    }
    
    &:active {
        opacity: 0.5;
    }
    
    svg {
        color: white;
        font-size: 24px;
    }
`;

export default class MobilePortraitHeader extends Component {
    handleAction = action => {
        const { onClose, registerUserInteraction } = this.props;

        if (action) {
            action();
            onClose?.();
            registerUserInteraction?.();
        }
    }

    render() {
        const {
            showThumbnailsPane,
            onSharePresentation,
            onEditOnDesktop,
            canEditPresentation
        } = this.props;

        return (
            <HeaderContainer>
                <ActionButton
                    onClick={() => AppController.showLibrary()}
                    aria-label="Home"
                >
                    <LogoText>
                        <HomeIcon />
                    </LogoText>
                </ActionButton>
                <ActionsContainer>
                    <ActionButton
                        onClick={() => this.handleAction(showThumbnailsPane)}
                        aria-label="Grid View"
                    >
                        <ViewModuleIcon />
                    </ActionButton>
                    {canEditPresentation && (
                        <ActionButton
                            onClick={() => this.handleAction(onEditOnDesktop)}
                            aria-label="Edit"
                        >
                            <EditIcon />
                        </ActionButton>
                    )}
                    {canEditPresentation && (
                        <ActionButton
                            onClick={() => this.handleAction(onSharePresentation)}
                            aria-label="Share"
                        >
                            <ShareIcon />
                        </ActionButton>
                    )}
                </ActionsContainer>
            </HeaderContainer>
        );
    }
}
